import { FieldArray, type FormikErrors, type FormikTouched, type FormikValues } from 'formik';
import React from 'react';
import Button from '../../../../components/button';
import FormSelect from '../../../../components/dropdown/formSelect';
import Heading from '../../../../components/typography';
import { COLORS } from '../../../../constants/style/color';
import { type OptionType, type UserType } from '../../../../types/common';
import CustomDropdown from '../../../../components/custom-dropdown';
import { Label } from '../../../../components/input-text/input.styled';
import CustomerRadio from '../../../../components/radio-button/customRadio';
import { AlignRadioButton } from '../../../../components/radio-button/radioButton.styled';

interface GroupProps {
  errors: FormikErrors<any> | any;
  touched: FormikTouched<any> | any;
  values: FormikValues;
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>;
  departmentOptions?: OptionType[];
  employeeTypeOptions?: OptionType[];
  jobTitleOptions?: UserType[];
  setFieldValue: any;
  setFieldTouched: any;
  handleChange: any;
}

const GroupOptions = ({
  errors,
  touched,
  values,
  departmentOptions,
  employeeTypeOptions,
  jobTitleOptions,
  handleRequest,
  handleChange,
  setFieldValue,
  setFieldTouched,
}: GroupProps): JSX.Element => {
  const handleUser = (userData: UserType, index: number): void => {
    const userInfo = values?.tradePreClearanceGroups[index]?.jobTitleIds;
    if (!(userInfo.includes(userData.value) === true)) {
      userInfo.push(userData.value);
      setFieldValue(`tradePreClearanceGroups.${index}.groupData`, true);
    } else {
      userInfo.splice(userInfo.indexOf(userData.value), 1);
      setFieldValue(`tradePreClearanceGroups.${index}.groupData`, false);
    }
    setFieldValue(`tradePreClearanceGroups.${index}.jobTitleIds`, [...userInfo]);
    setTimeout(() => setFieldTouched(`tradePreClearanceGroups.${index}.jobTitleIds`, true));
  };
  return (
    <div className='col-span-12' id="groupOptionsContainer">
      <Heading variant='h5' title='Add Participant Groups' className='group-title' />
      <Heading
        variant='body'
        title='Select one or more below'
        className='group-sub-title'
        color={COLORS.Gray}
      />
      <div id="groupOptionsFormContainer">
        <FieldArray
          name='tradePreClearanceGroups'
          render={(arrayHelpers) => {
            return (
              <>
                <div className='space-y-6' id="groupOptionsArrayContainer">
                  {(values?.tradePreClearanceGroups as boolean) &&
                    values.tradePreClearanceGroups.length > 0 &&
                    values.tradePreClearanceGroups.map((friend: any, index: number) => (
                      <div key={index} className='grid grid-cols-12 gap-4 mb-6' id={`groupOptionRow${index}`}>
                        <div className='col-span-11 space-y-4' id={`groupOptionFields${index}`}>
                          {/* <div className='col-span-1 md:col-span-9'> */}
                          <div className='grid grid-cols-1 md:grid-cols-3 gap-4' id={`groupOptionGrid${index}`}>
                            <FormSelect
                              // containerClassName='col-span-1'
                              label='Department'
                              placeholder='Select'
                              values={values}
                              name={`tradePreClearanceGroups.${index}.departmentId`}
                              id={`tradePreClearanceGroups.${index}.departmentId`}
                              errorValue={errors?.tradePreClearanceGroups?.[index]?.departmentId}
                              touchedValue={touched?.tradePreClearanceGroups?.[index]?.departmentId}
                              arrValue={values?.tradePreClearanceGroups[index]?.departmentId}
                              setFieldValue={setFieldValue}
                              onChange={(e: any) => {
                                handleChange(e);
                                setFieldValue(`tradePreClearanceGroups.${index}.groupData`, true);
                                setTimeout(() =>
                                  setFieldTouched(
                                    `tradePreClearanceGroups.${index}.departmentId`,
                                    true
                                  )
                                );
                              }}
                              errors={errors}
                              touched={touched}
                              allOptions={departmentOptions}
                              options={departmentOptions?.filter((item) => {
                                const filteredData = values.tradePreClearanceGroups.map(
                                  (option: Record<string, string | string[]>) => option.departmentId
                                );
                                return !(filteredData.includes(item.value) === true);
                              })}
                              required
                            />
                            <FormSelect
                              // containerClassName='col-span-1'
                              label='Employee Type '
                              placeholder='Select'
                              name={`tradePreClearanceGroups.${index}.employeeTypeId`}
                              id={`tradePreClearanceGroups.${index}.employeeTypeId`}
                              arrValue={values?.tradePreClearanceGroups[index]?.employeeTypeId}
                              errorValue={errors?.tradePreClearanceGroups?.[index]?.employeeTypeId}
                              touchedValue={
                                touched?.tradePreClearanceGroups?.[index]?.employeeTypeId
                              }
                              onChange={(e: any) => {
                                handleChange(e);
                                setFieldValue(`tradePreClearanceGroups.${index}.groupData`, true);
                                setTimeout(() =>
                                  setFieldTouched(
                                    `tradePreClearanceGroups.${index}.employeeTypeId`,
                                    true
                                  )
                                );
                              }}
                              errors={errors}
                              touched={touched}
                              allOptions={employeeTypeOptions}
                              options={employeeTypeOptions?.filter((item) => {
                                const filteredData = values.tradePreClearanceGroups.map(
                                  (option: Record<string, string | string[]>) =>
                                    option.employeeTypeId
                                );
                                return !(filteredData.includes(item.value) === true);
                              })}
                              values={values}
                              setFieldValue={setFieldValue}
                              required
                            />
                            <div className='col-span-1' id={`jobTitleContainer${index}`}>
                              <CustomDropdown
                                title={'Job Title'}
                                data={jobTitleOptions}
                                errorMessage={
                                  errors?.tradePreClearanceGroups?.[index]?.employeeTypeId
                                }
                                touchedValue={
                                  touched?.tradePreClearanceGroups?.[index]?.employeeTypeId
                                }
                                handleUser={(e) => {
                                  handleUser(e, index);
                                }}
                                checkedList={
                                  values?.tradePreClearanceGroups[index]?.jobTitleIds ?? []
                                }
                                cssStyles={{
                                  width: '225px',
                                  height:
                                    jobTitleOptions != null && jobTitleOptions?.length > 5
                                      ? '230px'
                                      : 'auto',
                                  contentHeight:
                                    jobTitleOptions != null && jobTitleOptions?.length > 5
                                      ? '200px'
                                      : 'auto',
                                  padding: '0',
                                  verticalGap: '8',
                                  column: 1,
                                }}
                                toggleItems={{
                                  showSearch: false,
                                  showTotal: false,
                                  displaySelected: true,
                                }}
                              />
                            </div>
                          </div>
                          <div className='grid grid-cols-1 md:grid-cols-3 gap-4' id={`radioButtonGrid${index}`}>
                            <div id={`section16Container${index}`}>
                              <Label>Is Section 16</Label>
                              <AlignRadioButton className='flex space-x-4'>
                                <CustomerRadio
                                  name={`tradePreClearanceGroups.${index}.isSection16`}
                                  labelClassName='fix-alignment'
                                  id={`tradePreClearanceGroups.${index}.isSection16Yes`}
                                  label='Yes'
                                  value={true}
                                  checked={values?.tradePreClearanceGroups[index]?.isSection16}
                                  onChange={() =>
                                    setFieldValue(
                                      `tradePreClearanceGroups.${index}.isSection16`,
                                      true
                                    )
                                  }
                                  errors={errors}
                                  touched={touched}
                                />
                                <CustomerRadio
                                  name={`tradePreClearanceGroups.${index}.isSection16`}
                                  labelClassName='fix-alignment'
                                  id={`tradePreClearanceGroups.${index}.isSection16No`}
                                  label='No'
                                  value={false}
                                  checked={
                                    values?.tradePreClearanceGroups[index]?.isSection16 === false
                                  }
                                  onChange={() =>
                                    setFieldValue(
                                      `tradePreClearanceGroups.${index}.isSection16`,
                                      false
                                    )
                                  }
                                  errors={errors}
                                  touched={touched}
                                />
                              </AlignRadioButton>
                            </div>
                            <div id={`rule144Container${index}`}>
                              <Label>Is Rule 144</Label>
                              <AlignRadioButton className='flex space-x-4'>
                                <CustomerRadio
                                  name={`tradePreClearanceGroups.${index}.isRule144`}
                                  labelClassName='fix-alignment'
                                  id={`tradePreClearanceGroups.${index}.isRule144Yes`}
                                  label='Yes'
                                  value={true}
                                  checked={values.tradePreClearanceGroups[index].isRule144}
                                  onChange={() =>
                                    setFieldValue(
                                      `tradePreClearanceGroups.${index}.isRule144`,
                                      true
                                    )
                                  }
                                  errors={errors}
                                  touched={touched}
                                />
                                <CustomerRadio
                                  name={`tradePreClearanceGroups.${index}.isRule144`}
                                  labelClassName='fix-alignment'
                                  id={`tradePreClearanceGroups.${index}.isRule144No`}
                                  label='No'
                                  value={false}
                                  checked={
                                    values.tradePreClearanceGroups[index].isRule144 === false
                                  }
                                  onChange={() =>
                                    setFieldValue(
                                      `tradePreClearanceGroups.${index}.isRule144`,
                                      false
                                    )
                                  }
                                  errors={errors}
                                  touched={touched}
                                />
                              </AlignRadioButton>
                            </div>
                            {/* </div> */}
                          </div>
                          {/* </div> */}
                        </div>
                        <div className='col-span-1 flex items-end justify-end' id={`deleteButtonContainer${index}`}>
                          {values.tradePreClearanceGroups.length > 1 && (
                            <div
                              className='flex items-end gap-2'
                              role='button'
                              id={`deleteGroupOption${index}`}
                              onClick={() => {
                                arrayHelpers.remove(index);
                              }}>
                              <span className='material-symbols-outlined text-red-600'>delete</span>
                              <Heading variant='body-s' title='Delete' color={`${COLORS.Gray}`} />
                            </div>
                          )}
                        </div>
                        {/* Divider line - only show between rows */}
                        {index < values.tradePreClearanceGroups.length - 1 && (
                          <div className='col-span-12 border-t border-gray-300 my-4'></div>
                        )}
                      </div>
                    ))}

                  {/* {errors?.tradePreClearanceGroups && touched?.tradePreClearanceGroups && (
                  <div className='col-span-12'>
                    <div className='error-message'>{errors?.tradePreClearanceGroups}</div>
                  </div>
                )} */}
                  <div className='col-span-12 mt-6' id="addAnotherCriteriaContainer">
                    <Button
                      title='Add another criteria'
                      type='button'
                      variant='primary-dark'
                      icon='group_add'
                      btnClassName='w-full'
                      id="addAnotherCriteriaButton"
                      onClick={() => {
                        arrayHelpers.push({
                          departmentId: null,
                          employeeTypeId: null,
                          jobTitleIds: [],
                          isSection16: null,
                          isRule144: null,
                          groupData: false,
                        });
                      }}
                    />
                  </div>
                </div>
              </>
            );
          }}
        />
      </div>
    </div>
  );
};

export default GroupOptions;
